module.exports = __webpack_public_path__ + "img/order-info.526b8ef9.png";